import { registerSW } from './sw-register';

import moment from 'jalali-moment';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import {
  AppContextProvider,
  UserContextProvider,
  SelfContextProvider,
  MessageContextProvider,
  UniversityContextProvider,
  CurrentReservesContextProvider
} from '@/context';
import '@szhsin/react-menu/dist/index.css';
import './reset.scss';
import App from './App.tsx';
import 'antd/dist/reset.css';
import '@/assets/flaticon/flaticon.css';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/effect-cards';
import './index.scss';
import './styles/typography.css';

registerSW();

moment.locale('fa');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      gcTime: 0,
      refetchOnWindowFocus: false,
    }
  }
});

const root = document.getElementById('root');
ReactDOM.createRoot(root!).render(
  <QueryClientProvider client={queryClient}>
    <UniversityContextProvider>
      <AppContextProvider>
        <UserContextProvider>
          <SelfContextProvider>
            <MessageContextProvider>
              <CurrentReservesContextProvider>
                <App />
              </CurrentReservesContextProvider>
            </MessageContextProvider>
          </SelfContextProvider>
        </UserContextProvider>
      </AppContextProvider>
    </UniversityContextProvider>
  </QueryClientProvider>
);
